<div class="card simple-stat-card background-{{backgroundClass}}" [class.disabled]="disabled">
  <div class="flex-wrap card-container pad-content  gap-2 background-{{backgroundClass}} {{isNew && newTagPosition==='below' ? 'flex-column py-1': 'flex-row'}}">

    <div class="flex flex-row gap-2 justify-content-start {{isNew && newTagPosition==='below' ? 'align-items-end w-full' : 'align-items-center'}}">
      <div *ngIf="customStyle" class="coloured-square {{customStyle}}-card">
        <span *ngIf="count >= 0" class="font-bold inner-square-count">{{count}}</span>
        <!-- <span *ngIf="isNew" class="font-bold inner-square-count text-black-alpha-80 text-sm vertical-align-middle">X-RACK</span> -->
      </div>

      <div  [innerHTML]="mainContent" ></div>
    </div>

    <div *ngIf="isNew || secondary" class="flex justify-content-end gap-2 {{isNew && newTagPosition==='below' ? 'w-full': 'flex-grow-1'}}">
      <p-tag *ngIf="isNew" value="{{count > 1 ? 'NUEVOS' : 'NUEVO'}}" styleClass="ptag-pad"></p-tag>
      <span *ngIf="secondary" class="secondary flex align-items-center text-sm text-black-alpha-50" [innerHTML]="secondary"></span>
    </div>
  </div>
</div>

<!--<div class="card simple-stat-card background-{{backgroundClass}}" [class.disabled]="disabled">-->
<!--  <div class="flex-row card-container pad-content background-{{backgroundClass}}">-->
<!--    <div *ngIf="customStyle" class="coloured-square {{customStyle}}-card">-->
<!--      <span *ngIf="count >= 0" class="font-bold inner-square-count">{{count}}</span>-->
<!--    </div>-->
<!--    <div class="flex flex-wrap justify-content-between main-container">-->
<!--      <div class="block" [innerHTML]="mainContent" class="main-content"></div>-->
<!--      <span *ngIf="secondary" class="secondary font-bold flex align-items-center" [innerHTML]="secondary"></span>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
